export default __webpack_public_path__ + "images/JO.675d3c3.png";